(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-tabcards"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    initFeatureTabcards();
  });

  // Re-initialize on Shopify section load events
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId && event.detail.sectionId.includes('feature-tabcards')) {
      initFeatureTabcards();
    }
  });

  function initFeatureTabcards() {
    const featureTabcardsSections = document.querySelectorAll('.feature-tabcards');
    
    featureTabcardsSections.forEach(function(section) {
      const tabs = section.querySelectorAll('.feature-tabcards__tab');
      const blocks = section.querySelectorAll('.feature-tabcards__blocks');
      const prevArrow = section.querySelector('.feature-tabcards__arrow--prev');
      const nextArrow = section.querySelector('.feature-tabcards__arrow--next');
      const navigation = section.querySelector('.feature-tabcards__navigation');
      
      // Remove existing event listeners to prevent duplicates
      tabs.forEach(function(tab) {
        const newTab = tab.cloneNode(true);
        tab.parentNode.replaceChild(newTab, tab);
      });
      
      // Re-select tabs after replacement
      const newTabs = section.querySelectorAll('.feature-tabcards__tab');
      
      // Handle tab clicks
      newTabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
          const tabId = this.getAttribute('data-tab-id');
          
          // Update active tab
          newTabs.forEach(function(t) { 
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          this.classList.add('active');
          this.setAttribute('aria-selected', 'true');
          
          // Find the active block to start the transition
          const activeBlock = Array.from(blocks).find(block => block.classList.contains('active'));
          
          // First start fading out the current active block
          if (activeBlock) {
            activeBlock.style.opacity = '0';
            activeBlock.style.visibility = 'hidden';
          }
          
          // After a short delay, show the new block
          setTimeout(() => {
            // Update active block
            blocks.forEach(function(block) {
              const blockId = block.getAttribute('data-block-id');
              block.classList.remove('active');
              
              if (blockId === tabId) {
                block.classList.add('active');
                setTimeout(() => {
                  block.style.opacity = '1';
                  block.style.visibility = 'visible';
                }, 50);
              }
            });
            
            // Update arrow states
            updateArrowStates();
          }, 300);
        });
      });
      
      // Arrow navigation
      if (prevArrow && nextArrow) {
        // Remove existing event listeners
        const newPrevArrow = prevArrow.cloneNode(true);
        prevArrow.parentNode.replaceChild(newPrevArrow, prevArrow);
        
        const newNextArrow = nextArrow.cloneNode(true);
        nextArrow.parentNode.replaceChild(newNextArrow, nextArrow);
        
        // Update references to point to the new elements
        const updatedPrevArrow = section.querySelector('.feature-tabcards__arrow--prev');
        const updatedNextArrow = section.querySelector('.feature-tabcards__arrow--next');
        
        // Add event listeners to new elements
        updatedPrevArrow.addEventListener('click', function(e) {
          e.preventDefault();
          const activeTabIndex = Array.from(newTabs).findIndex(function(tab) {
            return tab.classList.contains('active');
          });
          
          if (activeTabIndex > 0) {
            newTabs[activeTabIndex - 1].click();
          }
        });
        
        updatedNextArrow.addEventListener('click', function(e) {
          e.preventDefault();
          const activeTabIndex = Array.from(newTabs).findIndex(function(tab) {
            return tab.classList.contains('active');
          });
          
          if (activeTabIndex < newTabs.length - 1) {
            newTabs[activeTabIndex + 1].click();
          }
        });
        
        // Update arrow states function to use the updated references
        function updateArrowStates() {
          const activeTabIndex = Array.from(newTabs).findIndex(function(tab) {
            return tab.classList.contains('active');
          });
          
          updatedPrevArrow.classList.toggle('feature-tabcards__arrow--disabled', activeTabIndex === 0);
          updatedNextArrow.classList.toggle('feature-tabcards__arrow--disabled', activeTabIndex === newTabs.length - 1);
        }
        
        // Initialize arrow states
        updateArrowStates();
      } else {
        // Define an empty function if arrows don't exist
        function updateArrowStates() {}
      }
      
      // Handle responsive arrow visibility
      function handleResponsiveArrows() {
        if (!navigation) return;
        
        const showDesktop = navigation.getAttribute('data-show-desktop') === 'true';
        const showMobile = navigation.getAttribute('data-show-mobile') === 'true';
        
        if (window.innerWidth <= 749) {
          navigation.style.display = showMobile ? 'flex' : 'none';
        } else {
          navigation.style.display = showDesktop ? 'flex' : 'none';
        }
      }
      
      // Initial call for responsive arrows
      handleResponsiveArrows();
      
      // Remove existing resize listener to prevent duplicates
      window.removeEventListener('resize', handleResponsiveArrows);
      
      // Add resize listener
      window.addEventListener('resize', handleResponsiveArrows);
      
      // Ensure first tab is active
      if (newTabs.length > 0 && blocks.length > 0) {
        // Set first tab as active if none are active
        const hasActiveTab = Array.from(newTabs).some(function(tab) {
          return tab.classList.contains('active');
        });
        
        if (!hasActiveTab && newTabs[0]) {
          newTabs[0].classList.add('active');
          newTabs[0].setAttribute('aria-selected', 'true');
          
          const firstTabId = newTabs[0].getAttribute('data-tab-id');
          blocks.forEach(function(block) {
            if (block.getAttribute('data-block-id') === firstTabId) {
              block.classList.add('active');
            } else {
              block.classList.remove('active');
            }
          });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
